import React from "react"

import CheckoutFlowNavButtons from "~components/pages/listing/checkout/checkout-flow/checkout-flow-nav-buttons"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"

import { useCheckoutFlowNavButtonsProps } from "./checkout-flow-hooks"
import CheckoutFlowGuestsAndAddOnsStepContent from "./checkout-flow-guests-and-add-ons-step-content"
import CheckoutFlowStep from "./checkout-flow-step"

export default function CheckoutFlowGuestsAndAddOnsStep() {
    const { quote, listing, quotePackageBeingEdited, goToNextStep } =
        useCheckoutFlow()

    const {
        onContinueClickOverride,
        isLoading,
        isContinueDisabled,
        draftQuoteError,
    } = useCheckoutFlowNavButtonsProps({
        listing,
        quote,
        quotePackageBeingEdited,
        onCreateQuoteCompleted: ({ quoteId }) =>
            goToNextStep({
                quote_id: quoteId,
                package_id: null,
                quote_package_id: null,
                checkout_state: null,
            }),
    })

    return (
        <CheckoutFlowStep
            renderNavButtons={() => (
                <CheckoutFlowNavButtons
                    onContinueClickOverride={onContinueClickOverride}
                    isLoading={isLoading}
                    isContinueDisabled={isContinueDisabled}
                    error={draftQuoteError}
                />
            )}
        >
            <CheckoutFlowGuestsAndAddOnsStepContent />
        </CheckoutFlowStep>
    )
}
